import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import {Spinner} from '@primer/react'
import {clsx} from 'clsx'

import styles from './CommentDivider.module.css'

type CommentDividerProps = {
  isLoading?: boolean
  isHovered?: boolean
  large?: boolean
}

export const CommentDivider = ({large, isLoading, isHovered}: CommentDividerProps) => (
  <div className={styles.CommentDividerContainer}>
    <div
      className={clsx(styles.CommentDividerLeftLine, large ? styles.paddingBottomLarge : styles.paddingBottomDefault)}
    />
    {isLoading && <Spinner size={'small'} />}
    {isHovered && !isLoading && (
      <LoadingSkeleton height={'12px'} width={'100%'} className={styles.CommentDividerLoadingSkeleton} />
    )}
    <div
      className={clsx(styles.CommentDividerRightLine, large ? styles.paddingBottomLarge : styles.paddingBottomDefault)}
    />
  </div>
)
